<template>
  <div class="puzzle-container page-container">
    <v-header></v-header>
    <div class="page-wrap">
      <div class="content">
        <div class="main">
          <div class="side-menu">
            <div class="puzzle-image">
              <div class="button-group">
                <el-button @click="puzzleImage('X')" :class="{'active': puzzleType == 'X'}">横向拼接</el-button>
                <el-button @click="puzzleImage('Y')" :class="{'active': puzzleType == 'Y'}">竖向拼接</el-button>
                <div :class="{'puzzle-grid-container': puzzleType == 'G' && isGrid}">
                  <el-button @click="puzzleImage('G')" :class="{'active': puzzleType == 'G' && !isGrid}">网格拼图
                    <i class="el-icon-arrow-up icon-right" v-if="isGrid"></i>
                    <i class="el-icon-arrow-down icon-right" v-else></i>
                  </el-button>
                  <!-- 网格拼图 -->
                  <puzzle-image-by-grid
                    :isGrid="isGrid"
                    :selectedInstance="selectedInstance"
                    @changeCurrentPuzzleImage="changeCurrentPuzzleImage"
                    :innerGap="innerGap"
                    :outerMargin="outerMargin"
                    :strokeColor="strokeColor"
                  />
                </div>
                <div :class="['block', 'align-items', {'disabled': !fileList.length}]">
                  <span class="demonstration">内边框</span>
                  <el-slider v-model="innerGap" @change="" :disabled="!fileList.length"/>
                </div>
                <div :class="['block', 'align-items', {'disabled': !fileList.length}]">
                  <span class="demonstration">外边框</span>
                  <el-slider v-model="outerMargin"  @change="" :disabled="!fileList.length"/>
                </div>
                <div :class="['block', {'disabled': !fileList.length}]" style="margin-top: 10px;">
                  <span class="demonstration">边框颜色</span>
                  <div class="predefine-colors">
                    <div
                      :class="[{ selected: isActive === index }, 'predefine-selector']"
                      @click="selectColor(index)"
                      ref="predefineSelector"
                      v-for="(item, index) in predefineColors"
                      :key="item"
                      :style="{ backgroundColor: item }"
                    >
                    </div>
                    <el-color-picker
                      :open="true"
                      v-model="strokeColor"
                      :predefine="predefineColors"
                      @change="changeColorPicker"
                      :class="{'selected': isActive === 5}"
                      :disabled="!fileList.length"
                    />
                  </div>
                </div>
              </div>
              <el-divider></el-divider>
              <el-button class="cancel-custom" @click="handleCancel">重置</el-button>
              <v-download :fileList="imageList"></v-download>
            </div>
          </div>
          <div class="image-main-container">
            <div class="image-editor">
              <div class="editor-wrap" v-if="fileList.length">
                <img
                  :src="currentPuzzleImage.base64Url ? currentPuzzleImage.base64Url : currentPuzzleImage.url"
                  style="width:100%;height:100%;object-fit:contain"
                />
              </div>
               <div class="upload-tips" v-else>
                <p>支持图片批量上传</p>
                <el-upload
                  action="#"
                  accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.svg"
                  :file-list="fileList"
                  ref="dynamic"
                  :limit="30"
                  :on-change="handleChanged"
                  :on-exceed="(file, fileList) => handleExceed(file, fileList)"
                  :on-remove="handleRemove"
                  :auto-upload="false"
                  multiple
                >
                  <el-button size="large" type="default" class="upload-button">点击上传图片</el-button>
                </el-upload>
              </div>
            </div>
            <div class="image-list">
              <el-upload
                action="#"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.svg"
                :file-list="fileList"
                ref="dynamic"
                :limit="30"
                :show-file-list="true"
                :on-change="handleChanged"
                :on-exceed="(file, fileList) => handleExceed(file, fileList)"
                :on-remove="handleRemove"
                :auto-upload="false"
                multiple
              >
                <i class="el-icon-plus"></i>
                <div slot="file" 
                  slot-scope="{file}" 
                  @click="changeSelected(file,!file.checked)"
                >
                  <img
                    style="width:100%;height:100%;object-fit:contain"
                    :src="file.url"
                  />
                  <el-checkbox 
                    class="images-checkbox"
                    v-model="file.checked"
                    :checked="file.checked"
                    @click.stop.native="()=>{}"
                    @change="changeSelected(file, file.checked)"
                  >
                  </el-checkbox>
                  <div class="delete-images" @click.stop="handleRemove(file)">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import puzzleImageByGrid from './puzzleImageByGrid'
export default {
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],

      // 当前拼图后的图片
      currentPuzzleImage: {
        base64Url: ''
      },

      // 所有上传的图片实例
      allImageInstance: [],
      // 选中的图片实例
      selectedInstance: [],

      // 默认为横版
      puzzleType: 'X',
      isGrid: false, 

      innerGap: 0,    // 内边框(图片间距)
      outerMargin: 0, // 外边框(画布外边距)
      isActive: 5,
      strokeColor: '#FFF',
      predefineColors: ["#FF4500", "#FF8C00", "#FFD700", "#1E90FF", "#2CF528"]
    }
  },
  computed: {
    limit () {
      return parseInt(30 - this.fileList.length);
    },
    imageList () {
      if (!this.currentPuzzleImage.base64Url) {
        return this.fileList.filter(item => item.checked)
      } else {
        return [{ base64Url: this.currentPuzzleImage.base64Url, name: '拼图'}];
      }
    },
  },
  watch: {
    'selectedInstance.length' () {
      if (!this.selectedInstance.length || this.isGrid) {
        return;
      }

      this.puzzleImage(this.puzzleType)
    },
    'innerGap'() {
      if (!this.selectedInstance.length || this.isGrid) {
        return;
      }

      this.puzzleImage(this.puzzleType)
    },
    'outerMargin'() {
      if (!this.selectedInstance.length || this.isGrid) {
        return;
      }

      this.puzzleImage(this.puzzleType)
    },
    'strokeColor'() {
      if (!this.selectedInstance.length || this.isGrid) {
        return;
      }

      this.puzzleImage(this.puzzleType)
    },
  },
  methods: {
    // 重置
    handleCancel () {
      this.innerGap = 0;
      this.outerMargin = 0;
      this.strokeColor = '#fff';
      this.isActive = 5;
    },

    // 张数限制
    handleExceed(files, fileList) {
      // 如果总数大于30 或者是 当前选择的大于30都不能再上传。
      if (this.fileList.length > 30 || files.length > this.limit) {
        this.$message.error(`您选择的图片总数大于30张,您还可以选择${this.limit}张`)
      }
    },

    // 上传之前的钩子函数，限定上传图片的格式和大小
    checkImage (file) {
      var isImage = this.IMAGE_TYPE_LIST.indexOf(file.type) !== -1;
      var isLt10M = file.size / 1024 / 1024 < this.IMAGE_SIZE;

      if (!isImage) {
        this.$message.error('上传图片格式必须为jpg,jepg,png,jpg2,bmp,svg!');
        return false;
      }

      if (!isLt10M) {
        this.$message.error(`上传头像图片大小不能超过 ${this.IMAGE_SIZE}MB!`);
        return false;
      }
      return isImage && isLt10M;
    },

    //删除
    handleRemove(file) {
      if (this.fileList.length == 1) {
        this.currentPuzzleImage = {};
      }
      let removeFileIndex = this.fileList.findIndex(item => item.uid == file.uid);

      this.selectedInstance.splice(this.selectedInstance.findIndex(item => item.uid == file.uid), 1);

      this.fileList.splice(removeFileIndex, 1);
      if (!this.fileList.length) {
        return;
      }
      if (!this.fileList.some(item => item.checked == true)) {
        this.currentPuzzleImage = Object.assign({}, this.currentPuzzleImage, {
          base64Url: '',
          url: this.fileList[0].url
        })
      }
    },

    // 上传成功时的钩子函数，上传成功之后，默认选中所有的图片进行操作，用户也可以自行选中多张图片
    handleChanged (file, fileList) {
      fileList.map((item,index) => {
        // 默认选中所有上传的图片
        item.checked = true;
        this.setFileList(item)
      })
      this.fileList = fileList;
      this.currentImageInstance = {}
      
      var readFilePromise = [];
      readFilePromise.push(this.readFile(file));

      Promise.all(readFilePromise)
        .then(() => {
          // 上传图片后默认竖图拼接
          this.currentPuzzleImage = Object.assign({}, this.fileList[0]);
          // 找到显示在照片墙中的第一张照片实例
          let _selectedInstance = []
          this.allImageInstance.forEach(imgInstanceItem => {
            fileList.forEach(fileItem => {
              if (imgInstanceItem.uid == fileItem.uid) {
                _selectedInstance.push(imgInstanceItem)
              }
            })
          })
          this.selectedInstance = _selectedInstance

          this.puzzleImageY();
        })
    },

    readFile (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = (arg) => {
          const image = new Image();
          image.src = arg.target.result;
         
          image.onload = () => {
            file.url = arg.target.result;
            // file.base64Url = arg.target.result;
            this.setFileList(file);
            this.allImageInstance.push({uid: file.uid, img: image})
            resolve(arg);
          }
        };
        reader.onerror = reject;
      });
    },

    puzzleImage (type) {
      this.puzzleType = type;
      if (['X', 'Y'].includes(type)) {
        this.isGrid = false;
      }

      if (!this.selectedInstance.length && type !== 'G') {
        this.$message({
          type: 'error',
          message: '请选中需要操作的图片'
        })
        return;
      }
   
      switch(type) {
        case 'X':
          this.puzzleImageX();
          break;
        case 'Y':
          this.puzzleImageY();
          break;
        case 'G':
          this.isGrid = !this.isGrid;
          break;
      }
    },

    // 竖版
    puzzleImageY () {
      const width = 300;
      const heights = this.selectedInstance.map(item => width / item.img.width * item.img.height);
      const picHeights = heights.reduce((total, current) => total + current);
      const canvasWidth = this.outerMargin * 2 + width;
      const canvasHeight = this.outerMargin * 2 + (this.innerGap + (this.selectedInstance.length - 1)) + picHeights;

      const canvas = document.createElement('canvas');
      canvas.width = canvasWidth; //幕布的宽
      // 拼出来的图片的质量，0-1之间，越大质量越好
      const encoderOptions = 0.5;
      canvas.height = canvasHeight;
      const context = canvas.getContext('2d');
      context.fillStyle = this.strokeColor;
      context.fillRect(0, 0, canvasWidth, canvasHeight);

      let y = this.outerMargin;

      this.selectedInstance.forEach((item, index) => {
        const height = heights[index];
        context.drawImage(item.img, this.outerMargin, y, width, height);
        y += (height + this.innerGap);
      });
      this.$set(this.currentPuzzleImage, 'base64Url', canvas.toDataURL('image/png', encoderOptions))
    },

    // 横版
    puzzleImageX () {
      const height = 300;
      const widths = this.selectedInstance.map(item => height / item.img.height * item.img.width);
      const picWidths = widths.reduce((total, current) => total + current);
      const canvasWidth = this.outerMargin * 2 + (this.innerGap * (this.selectedInstance.length - 1)) + picWidths;
      const canvasHeight = this.outerMargin * 2 + height;

      const canvas = document.createElement('canvas');
      canvas.height = canvasHeight; //幕布的高
      // 拼出来的图片的质量，0-1之间，越大质量越好
      const encoderOptions = 0.5;
      canvas.width = canvasWidth;
      const context = canvas.getContext('2d');
      context.fillStyle = this.strokeColor;
      context.fillRect(0, 0, canvasWidth, canvasHeight); 

      let x = this.outerMargin;

      this.selectedInstance.forEach((item, index) => {
        const width = widths[index];
        context.drawImage(item.img, x, this.outerMargin, width, height);
        x += (width + this.innerGap);
      });
      
      this.$set(this.currentPuzzleImage, 'base64Url', canvas.toDataURL('image/png', encoderOptions))
    },

    // 当图片选中状态变化的时候触发的钩子函数
    changeSelected (file, value) {
      file.checked = value;
      this.setFileList(file)

      const currentImageInstance = this.allImageInstance.find(item => item.uid === file.uid)
      if (file.checked) {
        this.selectedInstance.push(currentImageInstance)
      } else {
        this.selectedInstance.splice(this.selectedInstance.findIndex(item => item.uid == file.uid), 1);
      }
    },

    setFileList (file) {
      this.$set(this.fileList, this.fileList.findIndex(item => item.uid == file.uid), file);
    },

    changeCurrentPuzzleImage (base64Url) {
      this.$set(this.currentPuzzleImage, 'base64Url', base64Url)
    },

    selectColor(index) {
      if (!this.fileList.length) {
        return;
      }
      this.isActive = index;
      this.strokeColor = this.predefineColors[index];
    },

    changeColorPicker(value) {
      if (this.predefineColors.includes(value)) {
        const index = this.predefineColors.findIndex(item => item == value);
        this.isActive = index;
      } else {
        this.isActive = 5;
      }
    }
  },
  components: {
    puzzleImageByGrid
  }
}
</script>

<style lang="scss" scoped>
.puzzle-container {
  .page-wrap {
    .content {
      .main {
        .side-menu {
          .puzzle-image {
            .el-button {
              padding: 8px 20px;
            }

            .button-group {
              margin: 15px 0;
              .el-button.el-button--default {
                margin-bottom: 10px;
                width: 100%;
                background-color: #fff;
                color: #000;
                border-color: #000;
                + .el-button {
                  margin-left: 0;
                }
              }

              .active.el-button.el-button--default {
                background-color: #3388FF;
                border-color: #3388FF;
                color: #fff;
              }

              .el-divider--horizontal {
                margin-top: 10px;
              }

              .block {
                display: flex;
                .demonstration {
                  font-size: 14px;
                  width: 70px;
                  text-align: left;
                }

                .el-slider {
                  width: 180px;
                }
              }

              .align-items {
                align-items: center;
                margin-bottom: 5px;
              }

              .block.disabled {
                color: #9A9A9A;
                .predefine-colors {
                  .predefine-selector {
                    position: relative;
                  }

                  .predefine-selector::after {
                    content: "";
                    width: 22px;
                    height: 22px;
                    position: absolute;
                    background-color: rgba(255,255,255,.7);
                    top: -1px;
                    left: -1px;
                    border-radius: 4px;
                    cursor: not-allowed;
                  }
                }
              }
            }

            .cancel-custom {
              width: 110px;
              margin: 8px 0;
              color: #fff;
              font-weight: 600;
              background-color: #333;
            }

            .cancel-custom:hover {
              background-color: #eee;
              border-color: #eee;
            }

            .puzzle-grid-container {
              border-radius: 5px;
              box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.4);
              padding: 10px 13px 20px 10px;
              margin: 10px 0px;
              .el-button.el-button--default {
                border-color: transparent;
                .el-icon-arrow-up {
                  top: 155px;
                }
              }
            }
          }

          .upload-tips {
            transform: translate(-50%, -50%);
          }
          .icon-right {
            position: absolute;
            right: 30px;
            top: 137px;
          }
        }

        .image-main-container {
          margin-left: 280px;
          margin-right: 0;
          .upload-tips {
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/images/puzzle/index.vue